import { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import DataTable from "react-data-table-component";

import { AuthContext } from "../contexts/AuthContext";

import TableLoader from "./TableLoader";
import { NotificationIcons, NotificationContent } from "./NotificationRow";

import useUserNotifications from "../hooks/useUserNotifications";
import { formatDateToSydneyTimeZone } from "../utils/dateUtils";

const AdminNotificationTable = ({ onDeleteClicked }) => {
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();

  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);

  const handleViewLabourerClicked = (labourerUserId) => {
    navigate('/admin/labour', { state: { labourerUserId } });
  };

  const { data, isLoading } = useUserNotifications(
    { userId: user?._id, page, perPage },
    { refreshInterval: 10 * 1000 }
  );

  const notifications = data?.notifications;
  const notificationCount = data?.count;

  const handlePageChange = page => {
    setPage(page);
  };

  const handlePerRowsChange = async (newPerPage, page) => {
    setPerPage(newPerPage);
    setPage(page);
  };

  const columns = [
    {
      name: "Title",
      selector: (row) => row.title,
      grow: 2,
      cell: (row) => (
        <div className='flex items-center gap-2'>
          <NotificationIcons notificationType={row.type} />
          <span>{row.title}</span>
        </div>
      )
    },
    {
      name: "Date",
      selector: (row) => row.createdAt,
      format: (row) => formatDateToSydneyTimeZone(row.createdAt)
    }
  ];

  return (
    <DataTable
      columns={columns}
      data={notifications}
      highlightOnHover
      striped
      pointerOnHover
      expandableRows
      expandableRowsComponent={NotificationContent}
      expandableRowsComponentProps={{ onViewLabourerClicked: handleViewLabourerClicked }}
      pagination
      paginationServer
      progressPending={isLoading}
      progressComponent={<TableLoader />}
      paginationTotalRows={notificationCount}
      paginationRowsPerPageOptions={[10, 20, 50]}
      paginationPerPage={perPage}
      onChangePage={handlePageChange}
      onChangeRowsPerPage={handlePerRowsChange}
    />
  );
}

export default AdminNotificationTable;
